import React from 'react';
import type { Resource as ProductionResource, ResourceInput } from 'sr-types/lib/production/v1/graphql';
import AttributesSidePanel from '../attributes/AttributesSidePanel';
import { ENTITY_CONSTANTS } from '../common/constants/entityConstants';
import { useProductionResourceDetailsData } from '../production/helpers/productionApi';

type ResourceAttributesSidePanelProps = {
    entityId: string;
    entityName: string;
    onClose: () => void;
    onSaveEntity: (values: ProductionResource & ResourceInput, isDeletingAttribute: boolean) => Promise<string | undefined>;
};

export default function ResourceAttributesSidePanel({
    entityId,
    entityName,
    onClose,
    onSaveEntity
}: ResourceAttributesSidePanelProps) {
    const { productionResourceDetailsData, productionResourceDetailsLoading } = useProductionResourceDetailsData(
        entityId,
        !entityId
    );
    const resource = productionResourceDetailsData?.resource;

    return (
        <AttributesSidePanel<ProductionResource & ResourceInput>
            entityId={entityId}
            entityName={entityName || resource?.name || ''}
            entity={ENTITY_CONSTANTS.resource}
            entityValues={resource}
            isEntityLoading={productionResourceDetailsLoading}
            onClose={onClose}
            onSaveEntity={onSaveEntity}
        />
    );
}
